import React from "react";
import { jsonKeyMapping } from "../../../Config/Constants";
import { TemplateObject } from "../../../Models/TemplateObject";
import FaqComponent from "../../Shared/FaqComponent";
import PreviewComponent from "../../Shared/PreviewComponent";
import Template from "../../Template/Template";

type Props = {
  template: string;
  stepDetails: TemplateObject;
  templatePrev?: React.RefObject<HTMLDivElement>;
};

const FormPreview = ({ template, stepDetails, templatePrev }: Props) => {
  return (
    <>
      {stepDetails[jsonKeyMapping.FORM_GROUP] &&
        stepDetails[jsonKeyMapping.FORM_GROUP].length > 0 && (
          <div
            className="col-lg-3 previewdisplay lgwidth"
            /* Added no display to col-lg-3m. In order to hide preview on form page */
            style={{ display: "none" }}
          >
            <div className="card scrollable-div leftsidebar">
              {/* ACTION BUTTON */}

              {/* FORM LIVE PREVIEW */}
              <div className="card-body bg-grey p-0">
                <div className="form_design">
                  <div className="formpreview">
                    <div style={{ marginTop: 80 }}>
                      <Template templateKey={template} isInnerPage templatePrev={templatePrev} />
                    </div>
                  </div>
                  <div className="preview-heading d-flex justify-content-md-center p-20 bg-grey">
                    <PreviewComponent />
                    {stepDetails[jsonKeyMapping.FAQ] &&
                      stepDetails[jsonKeyMapping.FAQ].length > 0 && (
                        <FaqComponent
                          faqContentList={stepDetails[jsonKeyMapping.FAQ]}
                        />
                      )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
    </>
  );
};

export default FormPreview;
